/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Container = styled.div`
  color: ${token('color.text.inverse', colors.N0)};
  padding: ${gridSize() * 2}px ${gridSize() * 3}px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const PanelButton = styled(Button)`
  &:hover,
  &:focus {
    background-color: ${token('color.background.neutral.hovered', colors.DN70)};
  }
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: ${gridSize()}px;
`;

export const HeaderHeading = styled.h2`
  color: ${token('color.text.inverse', colors.N0)};
`;

export const LoadingState = styled.section`
  margin: ${gridSize() * 4}px auto;
`;

export const TableSection = styled.section`
  margin-top: ${gridSize() * 4}px;
`;

// h500/h4 font-weight is inconsistent with typography library
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7031
export const TableHeading = styled.h4`
  font-weight: 500;
  color: ${token('color.text.inverse', colors.N0)};
  margin-bottom: ${gridSize()}px;
`;

export const TableRow = styled.div`
  display: flex;
  & > * {
    flex: 1;
  }
`;

export const TableRowKey = styled.b`
  color: ${token('color.text', colors.DN500)};
`;

export const DescriptionHeader = styled.div`
  align-items: baseline;
  display: flex;
  margin-bottom: ${gridSize()}px;
`;
